__turbopack_context__.v({
  "bundle-logo": "ProfileBanners-module-scss-module__hVwvqG__bundle-logo",
  "profile-banners": "ProfileBanners-module-scss-module__hVwvqG__profile-banners",
});
